<form [formGroup]='formDetails'>
  <div class="card mb-2 wow detalle-cliente">
    <div class="card-body justify-content-between">
      <div class="row filtros-header" style="
        border-bottom: 1px solid #dee2e6;
        justify-content: space-between;
        align-items: center;
      ">

        <div class="col">
          <h4>
            Agregar productos
          </h4>
        </div>
        <div class="col">
          <h4></h4>
        </div>

      </div>

      <div class="filtros-body">
        <div class="row">
          <div class="col" style="max-width: 150px;">
            <div class="md-form">
              <input value="" type="text" id="codProduct" class="form-control" placeholder="000" required #codProduct
                [readOnly]="mode === 'SHOW'" formControlName="codigoProducto" />
              <label for="codProduct">Cód. de producto</label>
              <div *ngIf="
                    formDetails.get('codigoProducto').invalid &&
                    (formDetails.get('codigoProducto').dirty ||
                    formDetails.get('codigoProducto').touched)
                  ">
                <mdb-error *ngIf="formDetails.get('codigoProducto').hasError('required')">Ingrese código de
                  producto
                </mdb-error>
              </div>
            </div>
          </div>
          <div class="col d-flex">
            <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
              [disabled]="mode === 'SHOW'" (click)="abrirModalSeleccionarProducto()">
              <mdb-icon fas icon="search"></mdb-icon>
            </button>
            <h6 class="text-info" style="display: contents;" *ngIf="productoSeleccionado">
              {{ productoSeleccionado.descripcion}}
            </h6>
          </div>
          <!-- <div class="col">
            <div class="md-form">
              <mdb-select [multiple]="true" [filterEnabled]="true" [options]="optionsMedida" [highlightFirst]="false"
                placeholder="Seleccionar medida"></mdb-select>
              <label>Medida</label>
            </div>
          </div> -->
          <div class="col" style="max-width: 150px;">
            <div class="md-form">
              <mdb-select [options]="optionsFormato" placeholder="Formato" [filterEnabled]="true"
                formControlName="formato">
              </mdb-select>
              <label>Formato</label>
              <div *ngIf="
                    formDetails.get('formato').invalid &&
                    (formDetails.get('formato').dirty ||
                    formDetails.get('formato').touched)
                  ">
                <mdb-error *ngIf="formDetails.get('formato').hasError('required')">Ingrese formato
                </mdb-error>
              </div>
            </div>
          </div>
          <div class="col" style="max-width: 150px;">
            <div class="md-form">
              <input value="" type="text" id="cant" class="form-control" placeholder="Ingrese cantidad" required #cant
                formControlName="cantidad" monto />
              <label for="cant">Cantidad</label>
              <div *ngIf="
                    formDetails.get('cantidad').invalid &&
                    (formDetails.get('cantidad').dirty ||
                    formDetails.get('cantidad').touched)
                  ">
                <mdb-error *ngIf="formDetails.get('cantidad').hasError('required')">Ingrese cantidad
                </mdb-error>
                <mdb-error *ngIf="formDetails.get('cantidad').hasError('min')">Cantidad debe ser mayor a 0
                </mdb-error>
                <mdb-error
                  *ngIf="formDetails.get('cantidad').value > 1 &&  formDetails.get('formato').value && formDetails.get('formato').value.includes('MED')">
                  La cantidad debe ser 1 o menos cuando el formato contiene 'MED'
                </mdb-error>
              </div>
            </div>
          </div>
          <div class="col" style="max-width: 150px;">
            <div class="md-form">
              <label for="precioUnitario">Precio unitario</label>
              <span class="value monto" *ngIf="formDetails.get('precioUnitario').value !== null">
                $ {{formDetails.get('precioUnitario').value | numerico }}</span>
              <span class="value monto" *ngIf="formDetails.get('precioUnitario').value === null"></span>
              <span *ngIf="
                    formDetails.get('precioUnitario').invalid &&
                    (formDetails.get('precioUnitario').dirty ||
                    formDetails.get('precioUnitario').touched)
                  ">
                <mdb-error *ngIf="formDetails.get('precioUnitario').hasError('required')">Ingrese precio unitario
                </mdb-error>
              </span>
            </div>
          </div>


          <div class="col" style="max-width: 150px;">
            <div class="md-form">
              <label for="descuento">Descuento</label>
              <div class="dcto-box">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <div class="input-group-text">%</div>
                  </div>
                  <input mdbInput type="text" id="descuentoPorcent" class="form-control py-0" #descuentoPorcent
                    [readOnly]="DescProducto > 0 || mode === 'SHOW'" formControlName="descuento">
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- FOOTER -->
    <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6;">
      <div class="d-sm-flex p-1 align-items-center">
        <span class="badge badge-info" *ngIf="cantidadProductos > 0">
          Productos: {{cantidadProductos}}
        </span>
        <span class="badge badge-secondary" *ngIf="cantidadProductos === 0">
          Sin productos
        </span>
      </div>

      <div>
        <app-api-button [disabled]="mode === 'SHOW' || loadingFormatoPrecio" (click2)="agregarProducto()"
          [processing]="processing">
          {{ loadingFormatoPrecio ? 'Aplicando precio costo...' : 'Agregar producto' }}
        </app-api-button>
      </div>
    </div>
  </div>

  <!-- <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6;">
    <div class="row">
      {{ formDetails.value | json }}
    </div>
  </div> -->
</form>

<!-- Listado ADD -->
<div class="card mb-2 wow" *ngIf="mode === 'ADD'">
  <div class="card-body" *ngIf="currentProcess">
    <div class="row">
      <div class="col">
        <div class="table-responsive">
          <table class="table table-striped table-hover table-sm align-middle">
            <thead class="grey lighten-2">
              <tr>
                <!-- <th scope="col">
                  <mdb-checkbox></mdb-checkbox>
                </th> -->
                <th scope="col">Código</th>
                <th scope="col">Descripción</th>
                <th scope="col">Cantidad</th>
                <th scope="col">Formato</th>
                <th scope="col">Precio $</th>
                <th scope="col">Desc. %</th>
                <th scope="col">Desc. Máx. %</th>
                <th scope="col">Total $</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let producto of currentProcess.productDocument">
                <!-- <td>
                  <mdb-checkbox></mdb-checkbox>
                </td> -->
                <td>{{ producto.codigo }}</td>
                <td>{{ producto.descripcion_producto }}</td>
                <td>{{ producto.cantidad | numerico }}</td>
                <td>{{ producto.formato_nombre }}</td>
                <td>$ {{ producto.precio | numerico }}</td>
                <td>{{ producto.descuento | numerico }}</td>
                <td>0</td>
                <td>$ {{ producto.monto_total_neto | numerico }}</td>
                <td>
                  <button class="btn-actions-sm" color="primary" mdbBtn type="button" mdbWavesEffect
                    (click)="eliminarProducto(producto)">
                    <mdb-icon fas icon="trash"></mdb-icon>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <div class="table-responsive mt-1">
          <table class="table table-striped table-hover table-sm align-middle">
            <thead class="blue lighten-5">
              <tr>
                <th scope="col">SubTotal</th>
                <th scope="col">Descto.</th>
                <th scope="col">impto. Adic.</th>
                <th scope="col">Exento</th>
                <th scope="col">Neto</th>
                <th scope="col">IVA</th>
                <th scope="col">TOTAL</th>
              </tr>
            </thead>
            <tbody class="blue lighten-5">
              <tr>
                <td>$ {{ currentProcess.documentTotal.subtotal | numerico }}</td>
                <td>$ {{ currentProcess.documentTotal.descuento | numerico }}</td>
                <td>$ {{ currentProcess.documentTotal.impuesto_adicional | numerico }}</td>
                <td>$ {{ currentProcess.documentTotal.exento | numerico }}</td>
                <td>$ {{ currentProcess.documentTotal.neto | numerico }}</td>
                <td>$ {{ currentProcess.documentTotal.iva | numerico }}</td>
                <td><strong>$ {{ currentProcess.documentTotal.total | numerico }}</strong></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- listado EDIT -->
<div class="card mb-2 wow" *ngIf="mode === 'EDIT' || mode === 'SHOW'">
  <div class="card-body" *ngIf="currentProcess">
    <div class="row">
      <div class="col">
        <div class="table-responsive">
          <table class="table table-striped table-hover table-sm align-middle">
            <thead class="grey lighten-2">
              <tr>
                <!-- <th scope="col">
                  <mdb-checkbox></mdb-checkbox>
                </th> -->
                <th scope="col">Código</th>
                <th scope="col">Descripción</th>
                <th scope="col">Cantidad</th>
                <th scope="col">Formato</th>
                <th scope="col">Precio $</th>
                <th scope="col">Desc. %</th>
                <th scope="col">Desc. Máx. %</th>
                <th scope="col">Total $</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let producto of currentProcess.productDocument">
                <!-- <td>
                  <mdb-checkbox></mdb-checkbox>
                </td> -->
                <td>{{ producto.codigo }}</td>
                <td>{{ producto.descripcion_producto }}</td>
                <td>
                  <div class="m-0" style="max-width: 100px;">
                    <input value="producto.cantidad" type="text" class="form-control" required monto min="1"
                      [(ngModel)]="producto.cantidad" name="cantidad" #cantidad="ngModel" [readonly]=""
                      [disabled]="producto.formato.includes('MED') || producto.linea != inputLinea" />
                  </div>
                  <div>
                    <mdb-error style="position: static;" *ngIf="producto.cantidad === ''">
                      Cantidad no válida
                    </mdb-error>
                  </div>
                  <!-- {{ producto.cantidad | numerico }} -->
                </td>
                <td>{{ producto.formato_nombre }}</td>
                <td>$ {{ producto.precio | numerico }}</td>
                <td>
                  <div class="m-0" style="max-width: 100px;">
                    <input *ngIf="producto.descuento_especial == 0" value="producto.descuento" type="text"
                      class="form-control" required min="1" [(ngModel)]="producto.descuento" name="descuento"
                      #descuento="ngModel" [readonly]="" [disabled]="producto.linea != inputLinea" />
                    <input *ngIf="producto.descuento_especial > 0" value="producto.descuento_especial" type="text"
                      class="form-control" required min="1" [ngModel]="producto.descuento_especial"
                      (ngModelChange)="producto.descuento_especial=$event" name="descuento" #descuento="ngModel"
                      [readonly]="" [disabled]="producto.linea != inputLinea" />
                  </div>
                  <div>
                    <mdb-error style="position: static;" *ngIf="producto.descuento === ''">
                      Descuento no válido
                    </mdb-error>
                  </div>
                  <!-- {{ producto.descuento | numerico }} -->
                </td>
                <td>
                  <div class="m-0" style="max-width: 100px;">
                    <input value="producto.descuento_tope" type="text" class="form-control" required min="1"
                      [(ngModel)]="producto.descuento_tope" name="descuentoTope" #descuentoTope="ngModel" [readonly]=""
                      [disabled]="producto.descuento_tope >= 0" />
                    <!-- <input *ngIf="producto.descuento_tope > 0" value="producto.descuento_tope" type="text"
                      class="form-control" required min="1" [ngModel]="producto.descuento_tope  | number:'1.0-0'"
                      (ngModelChange)="producto.descuento_tope=$event" name="descuentoTope" #descuentoTope="ngModel"
                      [readonly]="" [disabled]="producto.linea != inputLinea" /> -->
                  </div>
                  <div>
                    <mdb-error style="position: static;" *ngIf="producto.descuento_tope === ''">
                      Descuento no válido
                    </mdb-error>
                  </div>
                  <!-- {{ producto.descuento | numerico }} -->
                </td>
                <td>$ {{ producto.monto_total_neto | numerico }}</td>
                <td class="form-group row justify-content-center" style="margin-bottom: 0;">
                  <div>
                    <button [disabled]="mode === 'SHOW' || (editingProduct && editingProduct !== producto)"
                      *ngIf="producto.linea != inputLinea" class="btn-actions-sm" color="secondary" mdbBtn type="button"
                      mdbWavesEffect (click)="EditarProducto(producto)">
                      <mdb-icon fas icon="edit"></mdb-icon>
                    </button>
                    <button [disabled]="mode === 'SHOW'" *ngIf="producto.linea == inputLinea" class="btn-actions-sm"
                      color="success" mdbBtn type="button" mdbWavesEffect
                      (click)="ProcesoEditarPedidoCompletado(producto)">
                      <mdb-icon fas icon="check"></mdb-icon>
                    </button>
                  </div>
                  <button [disabled]="mode === 'SHOW'" class="btn-actions-sm" color="primary" mdbBtn type="button"
                    mdbWavesEffect (click)="eliminarProducto(producto)">
                    <mdb-icon fas icon="trash"></mdb-icon>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="row" *ngIf="currentProcess.documentTotal">
      <div class="col">
        <div class="table-responsive mt-1">
          <table class="table table-striped table-hover table-sm align-middle">
            <thead class="blue lighten-5">
              <tr>
                <th scope="col">SubTotal</th>
                <th scope="col">Descto.</th>
                <th scope="col">impto. Adic.</th>
                <th scope="col">Exento</th>
                <th scope="col">Neto</th>
                <th scope="col">IVA</th>
                <th scope="col">TOTAL</th>
              </tr>
            </thead>
            <tbody class="blue lighten-5">
              <tr>
                <td>$ {{ currentProcess.documentTotal.subtotal | numerico }}</td>
                <td>$ {{ currentProcess.documentTotal.descuento | numerico }}</td>
                <td>$ {{ currentProcess.documentTotal.impuesto_adicional | numerico }}</td>
                <td>$ {{ currentProcess.documentTotal.exento | numerico }}</td>
                <td>$ {{ currentProcess.documentTotal.neto | numerico }}</td>
                <td>$ {{ currentProcess.documentTotal.iva | numerico }}</td>
                <td><strong>$ {{ currentProcess.documentTotal.total | numerico }}</strong></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- MODAL DE CONFIRMACION -->
<app-modal-confirm></app-modal-confirm>


<!-- MODAL seleccionarProducto -->
<app-modal-seleccionar-producto (onSelect)="onProductoSeleccionado($event)" [showFiltroActivoInactivo]="false"
  (onNotFound)="onProductoNoEncontrado($event)" (onRemoteQuery)="getProducts($event)">
</app-modal-seleccionar-producto>
